module.exports = __webpack_public_path__ + "static/media/Artboard24.be232418.png";